import React from 'react';

export default function HealthCheck() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', paddingTop:'2rem' }}>
      <h2>Health Check</h2>
    </div>
  );
}
